'use client'
import CusTitle from "@/components/Home2/CusTitle.tsx";
import { useCategory } from "@/context/CategoriesContext.tsx";
import { Empty, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { defaultLocale } from "@/config.ts";
import { getChannelLanguageMap } from "@/lib/api/channel.ts";
import { executeGraphQL } from "@/lib/utils/graphql.ts";
import {
    ProductCountableEdge,
    ProductListByCategoryDocument,
    ProductListByCategoryQuery,
    ProductListItemFragment,
} from "@/gql/graphql.ts";
import { handleGraphqlLocale } from "@/lib/utils/util.ts";
import { UnknownOptions } from "@stripe/react-stripe-js/src/utils/extractAllowedOptionsUpdates.ts";
import Image from "next/image";
import { filterCateImg } from "@/components/Home2/Collection.tsx";
import { Link } from "@/navigation.ts";
import { useTranslations } from "next-intl";
import { replaceImgUrl } from "@/lib/utils.ts";

const CommonProductShowCase = ({ locale }: { locale: string }) => {
    const t = useTranslations();
    const { categories } = useCategory();
    const [items, setItems] = useState([]);
    const [activeSlug, setActiveSlug] = useState<string>('');
    const [productList, setProductList] = useState<ProductListByCategoryQuery>();
    const [loading, setLoading] = useState(true);

    const getProduct = async () => {
        const channel = (await getChannelLanguageMap())[defaultLocale];
        setLoading(true);
        const productData = await executeGraphQL(ProductListByCategoryDocument, {
            withAuth: false,
            variables: { first:8, locale: handleGraphqlLocale(locale || defaultLocale), channel: channel, slug: activeSlug },
        });
        setLoading(false);
        return productData;
    }

    useEffect(() => {
        if (activeSlug) {
            getProduct().then(res => {
                setProductList(res);
            })
        }
    }, [activeSlug])

    useEffect(() => {
        if (categories && categories.edges.length) {
            setActiveSlug(categories.edges[0].node.slug);
            const list = categories.edges.map(item => ({ key: item.node.slug, label: locale === defaultLocale ? item.node.name : item.node.translation ? item.node.translation.name : item.node.name, children: null }));
            setItems(list);
        }
    }, [categories])

    return <section className="bg-[#f5f5f5] pt-10 pb-20">
        <div className="container">
            <CusTitle homeTitle={t('resource.Common Product ShowCase')} className="text-center text-[3rem] !pt-12 !pb-6 max-md:py-8"></CusTitle>
            <div className="flex items-center justify-center">
                <p className="text-gray-500 pb-5 w-[80%] text-center">
                    {t('resource.as81as81f')}
                </p>
            </div>
            <Tabs defaultActiveKey={activeSlug} items={items} centered onChange={(key) => setActiveSlug(key)} />
            {
                loading ? <div className="h-[400px] flex justify-center items-center"><Spin size="large" /></div> : <div>
                    {productList && productList?.category?.products?.edges.length > 0 ? <ul className="grid grid-cols-4 max-md:grid-cols-2 gap-2 ">
                        {productList?.category?.products?.edges.map(productItem => {
                            return <li key={productItem.node.id} className="rounded-sm bg-white overflow-hidden relative">
                                <Link href={'/product/' + productItem.node.slug}>
                                    <Image src={replaceImgUrl(filterCateImg(productItem.node.metadata)[0]?.url) || "/image/default-image.webp"} alt={productItem.node.name} width={500} height={500} className="w-full h-64 object-cover rounded-sm transition-all duration-700 hover:scale-110" />
                                    <Image src="/image/home/720.png" alt="720.png" height={20} width={20} className="absolute right-2 bottom-2"></Image>
                                </Link>
                            </li>
                        })}
                    </ul> : <div><Empty /></div>}
                </div>
            }
        </div>
    </section>
}

export default CommonProductShowCase
